export default __webpack_public_path__ + "static/media/manholeCover-show2.ffe5ba59.png";